export default function EmployerHomePage () {
  return (
    <>
      <h1 className='heading-lg mb-6'>Home</h1>
    </>
  )
}
